import { putAfericaoBico } from '../offline/api';
import { compressImage } from '../utils/imageCompression';

export async function registrarBico(afericaoId, numeroBico, valor, imagemBlob) {
  // Obter localização atual
  const position = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 10000
    });
  });

  const localizacaoLat = position.coords.latitude;
  const localizacaoLng = position.coords.longitude;

  // Criar FormData para envio
  const formData = new FormData();
  formData.append('valor', valor.toString());
  formData.append('localizacaoLat', localizacaoLat.toString());
  formData.append('localizacaoLng', localizacaoLng.toString());

  // Adicionar imagem como blob (bytes)
  if (imagemBlob) {
    // Log do tamanho original
    const originalSizeKB = imagemBlob.size / 1024;
    console.log(`[RegistrarBico] Tamanho original da imagem: ${originalSizeKB.toFixed(2)}KB`);

    // Comprimir imagem se necessário (como fallback caso venha de outra fonte)
    // A compressão principal já é feita no CameraViewer, mas isso garante que
    // mesmo imagens de outras fontes sejam comprimidas
    let imagemFinal = imagemBlob;
    if (originalSizeKB > 500) {
      console.log('[RegistrarBico] Imagem maior que 500KB, comprimindo...');
      try {
        imagemFinal = await compressImage(imagemBlob, 1920, 1080, 0.85, 500);
        const compressedSizeKB = imagemFinal.size / 1024;
        console.log(`[RegistrarBico] Imagem comprimida: ${compressedSizeKB.toFixed(2)}KB (redução de ${((1 - compressedSizeKB / originalSizeKB) * 100).toFixed(1)}%)`);
      } catch (error) {
        console.warn('[RegistrarBico] Erro ao comprimir imagem, usando original:', error);
        imagemFinal = imagemBlob;
      }
    }

    formData.append('imagem', imagemFinal, 'afericao.jpg');
  }

  try {
    const response = await putAfericaoBico(afericaoId, numeroBico, formData);
    return response; // Retorna o objeto AfericaoBicoResponse com nivelAlerta
  } catch (error) {
    console.error('Erro ao registrar bico:', error);
    throw new Error('Erro ao registrar bico. Tente novamente.');
  }
}

